import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    '& .MuiAccordion-root': {
      borderRadius: 0,

      '& .MuiAccordionSummary-root': {
        backgroundColor: theme.palette.background.default,
      },

      '& .MuiAccordionSummary-content': {
        margin: 0,
      },

      '& .MuiCollapse-root': {
        backgroundColor: theme.palette.background.default,
      },

      '& .MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded': {
        minHeight: theme.spacing(6),
      },
    },
  },
}));
